import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6998c1f4f782d50014ce3fca/chronomind_ai_governance/src/app/page.tsx");
